import { HttpClient } from '@angular/common/http';
import {
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { firstValueFrom } from 'rxjs';
import { BookingService } from 'src/app/services';
import {
  EventBookingHistoryEvents,
  ListResponse,
} from 'src/app/types';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-do-payment-dialog',
  templateUrl: './do-payment-dialog.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class DoPaymentDialogComponent {
  bookingHistoryEvents!: ListResponse<EventBookingHistoryEvents>;
  selectedPaymentMethod = '';
  isPaymentHistoryLoaded = false;
  tenant!: string;

  @Input() bookingId!: number;

  constructor(
    private bookingService: BookingService,
    private http: HttpClient,
    public bsModalRef: BsModalRef<DoPaymentDialogComponent>
  ) {}

  ngOnInit(): void {
    this.tenant = environment.tenant;
    this.loadBookingHistoryEventsByBookingId();
  }

  doPayment(): void {
    this.bsModalRef.hide();
    this.bookingService.doPayment(this.bookingId);
  }

  close(): void {
    this.bsModalRef.hide();
  }

  private async loadBookingHistoryEventsByBookingId(): Promise<void> {
    try {
      this.bookingHistoryEvents = await firstValueFrom(
        this.http.get<
          ListResponse<EventBookingHistoryEvents>
        >(`/api/bookings/booking/${this.bookingId}/history`)
      );
      if (this.bookingHistoryEvents.total) {
        const latestEvent =
          this.bookingHistoryEvents.items[
            this.bookingHistoryEvents.total - 1
          ];
        this.selectedPaymentMethod =
          latestEvent.selectedPaymentMethod || '';
      }
    } finally {
      this.isPaymentHistoryLoaded = true;
    }
  }
}
